var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMu = function SvgMu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "m1.459 6.26 10.54 1.044L22.542 6.26A11.997 11.997 0 0 0 12 0C7.45 0 3.494 2.53 1.459 6.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M1.46 17.738 12 18.782l10.54-1.044C23.472 16.034 24 14.078 24 12l-12-1.043-12 1.043c0 2.08.529 4.034 1.46 5.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M1.46 6.261A11.946 11.946 0 0 0 0 12.001h24c0-2.08-.529-4.035-1.46-5.74H1.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DA544",
    d: "M12 24c4.548 0 8.506-2.531 10.54-6.261H1.46a11.997 11.997 0 0 0 10.54 6.26Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgMu;